import { render, staticRenderFns } from "./FormSectionCollapse.vue?vue&type=template&id=3e6f3ac0"
import script from "./FormSectionCollapse.vue?vue&type=script&lang=js"
export * from "./FormSectionCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports